import {ApproveRejectModalRequestType} from 'Interfaces'
import {connect} from 'react-redux'

import {AppDispatch} from 'Store'
import {rejectInterviewInvitation} from 'Store/Actions'
import {ModalInterviewInvitationReject} from './ModalInterviewInvitationReject'

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  rejectInterviewInvitation: (payload: ApproveRejectModalRequestType) =>
    dispatch(rejectInterviewInvitation(payload)),
})

export const ModalInterviewInvitationRejectContainer = connect(
  null,
  mapDispatchToProps
)(ModalInterviewInvitationReject)
